import Catalyst from '@Services/Catalyst';
import { getProjectRouteLevelContent } from '@Pages/RetroSynthesis/ProjectRoute/analytics';

export const onExportPopupOpened = ({ projectId, route, pageName, projectInfo }) => {
  Catalyst.trackEvent('contentExportStart', {
    content: [...getProjectRouteLevelContent({ projectId, routeId: route.id, routeType: route.routeType, projectInfo })],
    link: {
      name: `export:${pageName}:start`, // for tree view (page = tree) and for the table view (page = table)
      type: 'retrosynthesis',
    },
  });
};

export const onExportStarted = ({ projectId, route, pageName, format, projectInfo, count, selectedOnly }) => {
  const content = getProjectRouteLevelContent({ projectId, routeId: route.id, routeType: route.routeType, projectInfo }).map((c) => ({
    ...c,
    exportType: `contains:${selectedOnly ? 'selected examples' : 'all'}`,
    format, // e.g. 'pdf', 'xls'
  }));
  Catalyst.trackEvent('rowsExported', {
    content,
    link: {
      name: `export:${pageName}:success`, // for tree view (page = tree) and for the table view (page = table)
      type: 'retrosynthesis',
    },
    export: {
      rows: count, // e.g. '1', '100'
    },
  });
};
